module.exports = __webpack_public_path__ + "media/images/basket-c3ee2f7f.svg";